import { render, staticRenderFns } from "./cooperateTreasure.vue?vue&type=template&id=4d58e176&"
import script from "./cooperateTreasure.vue?vue&type=script&lang=js&"
export * from "./cooperateTreasure.vue?vue&type=script&lang=js&"
import style0 from "./cooperateTreasure.vue?vue&type=style&index=0&id=4d58e176&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports